var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetricFunnel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 245,
    viewBox: "0 0 158 245",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2203_2437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1.08496C0.989621 1.4972 1.6929 2.08064 2.60352 2.8125C4.53259 4.36288 7.39066 6.58139 11.1133 9.25586C18.5582 14.6046 29.4611 21.7804 43.2998 29.0957C70.8821 43.676 110.142 58.8149 156.94 61.1338V183.165C110.142 185.484 70.8821 200.624 43.2998 215.204C29.4611 222.519 18.5583 229.695 11.1133 235.044C7.3907 237.718 4.53259 239.937 2.60352 241.487C1.69294 242.219 0.989624 242.803 0.5 243.215V1.08496Z",
    fill: "url(#paint0_linear_2203_2437)",
    fillOpacity: 0.2,
    stroke: "url(#paint1_linear_2203_2437)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2203_2437",
    x1: 78.72,
    y1: 0,
    x2: 78.72,
    y2: 244.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FD5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FD5DE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2203_2437",
    x1: 157.44,
    y1: 0.0000164954,
    x2: 1.82148,
    y2: 112.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0DE60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FD5DE",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2203_2437"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 157.44,
    height: 244.3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricFunnel);
export default __webpack_public_path__ + "static/media/metric-funnel.9b919b24376a8e5ff15be213c8497d3b.svg";
export { ForwardRef as ReactComponent };